import { render, staticRenderFns } from "./group.vue?vue&type=template&id=88b45fce&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=88b45fce&prod&lang=scss&scoped=true"
import style1 from "./group.vue?vue&type=style&index=1&id=88b45fce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b45fce",
  null
  
)

export default component.exports